<template>
  <div ref="qrcodeList" class="qrcode-list" :class="{ 'is-empty': qrcodeList.length === 0 }">
    <el-skeleton v-if="qrcodeList.length === 0" :rows="7" />
    <div v-for="item, index in qrcodeList" :key="index" class="qrcode-box">
      <div class="qrcode" @click="handleActiveQrcode(index)" v-html="item.qrcode" />
      <div class="title">{{ index + 1 }}. {{ item.title }}{{ unit }}</div>
    </div>
    <el-backtop target=".qrcode-list" :right="370"></el-backtop>
  </div>
</template>

<script>
/**
 * @description 二维码列表
 * @created 2024/04/19 14:31:26
 * @property {Array} list 二维码列表
 * @property {String} unit 单位
 */
// 工具
import { onScrollToLower } from "@/utils/scroll"
import { generateQRCode } from "@/utils/qrcode"
export default {
  name: "QrcodeList",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    unit: String
  },
  data() {
    return {
      weight_list: [],
      page_index: 1,
      resize_observer: null,
      container_info: {
        offsetHeight: 0,
        realColumnCount: 0
      }
    }
  },
  computed: {
    size() {
      // weight_list 是全量数据，通过 onScrollToLower 方法进行分页，一次只渲染 size 条
      const { offsetHeight, realColumnCount } = this.container_info
      // 空白区的预设条数
      const blankCount = 10
      // 二维码容器的高度
      const qrcodeHeight = 233
      // 分页的条数
      return parseInt(offsetHeight / qrcodeHeight * realColumnCount) + blankCount
    },
    qrcodeList() {
      return this.weight_list.slice(0, this.page_index * this.size)
    }
  },
  watch: {
    list: {
      handler(newValue) {
        // 清除控制台
        console.clear()
        // 回到顶部
        this.page_index = 1
        this.$refs.qrcodeList.scrollTop = 0
        // 渲染二维码
        this.weight_list = this.$cloneDeep(newValue)
        this.handleSetQrcode()
      },
      deep: true
    }
  },
  mounted() {
    if ("ResizeObserver" in window) {
      this.resize_observer = new ResizeObserver(this.onResize)
      this.resize_observer.observe(this.$refs.qrcodeList)
    }
    this.$refs.qrcodeList.addEventListener("scroll", this.onScrollToLower)
  },
  beforeDestroy() {
    if ("ResizeObserver" in window) {
      this.resize_observer.unobserve(this.$refs.qrcodeList)
    }
    this.$refs.qrcodeList.removeEventListener("scroll", this.onScrollToLower)
  },
  methods: {
    onResize(entries) {
      // 整个容器的宽度
      const { offsetWidth, offsetHeight } = entries[0].target
      // 容器本身的内边距是 20，所以还要减去才能得到实际可用的宽度
      const containerWidth = offsetWidth - 20
      // 网格布局的间隙
      const gap = 20

      // 二维码容器的宽度 + gap
      const qrcodeWidth = 200 + gap
      // 求余得到剩余的宽度
      const count = containerWidth / qrcodeWidth
      const supplementWidth = containerWidth % qrcodeWidth / count / 2

      // 得到真实的每行容纳的个数
      const realColumnCount = parseInt(containerWidth / (qrcodeWidth + supplementWidth))
      this.container_info = {
        offsetHeight,
        realColumnCount
      }
    },
    onScrollToLower({ target }) {
      onScrollToLower(target, () => {
        if (this.qrcodeList.length < this.weight_list.length) {
          this.page_index++
          this.handleSetQrcode()
        }
      })
    },
    // 生成二维码
    generateQRCode(content, dark = "#000000") {
      return new Promise((resolve) => {
        generateQRCode({
          width: 200,
          height: 200,
          content,
          dark
        }, (url) => {
          resolve(url)
        })
      })
    },
    async handleSetQrcode() {
      console.warn(`二维码 第 ${this.page_index} 页`)
      console.time("耗时")
      for (let i = 0; i < this.page_index * this.size; i++) {
        // 不存在就结束循环
        if (!this.weight_list[i]) break
        // 不存在才生成
        if (!this.weight_list[i].qrcode) {
          const qrcode = await this.generateQRCode(this.weight_list[i].content)
          this.$set(this.weight_list[i], "qrcode", qrcode)
        }
      }
      console.timeEnd("耗时")
    },
    async handleActiveQrcode(index) {
      // 切换二维码颜色
      this.$set(this.weight_list[index], "isActive", !this.weight_list[index].isActive)
      const bgColor = this.weight_list[index].isActive ? "#069d13" : "#000000"
      const qrcode = await this.generateQRCode(this.weight_list[index].content, bgColor)
      this.$set(this.weight_list[index], "qrcode", qrcode)
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode-list {
  height: 100%;
  display: grid;
  padding: 20px;
  grid-gap: 20px;
  overflow-y: auto;
  box-sizing: border-box;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));

  &.is-empty {
    display: block;
  }

  .qrcode-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .qrcode {
      width: 200px;
      height: 200px;
      cursor: pointer;
    }

    .title {
      font-size: 20px;
      margin-top: 10px;
      font-weight: bold;
    }
  }
}
</style>
